import { Component, Prop, h } from '@stencil/core';

import { formatCurrency } from '../../../utils/utils.currency';

@Component({
  tag: 'dealer-boost-details-box',
  styleUrl: 'dealer-boost-details-box.css',
})
export class DealerBoostDetailsBox {
  @Prop() boost: number = 0;
  @Prop() dealerName: string = '';
  @Prop() initialOfferAmount: number = 0;

  render() {
    return (
      <div class="py-6 ">
        <div class="border-clrs-dark-green border-solid rounded-md py-2 px-4">
          <div class="border-b border-b-clrs-grey border-solid border-t-0 border-l-0 border-r-0 py-2">
            <div class="font-bold leading-6 text-lg">You Received A Dealer Boost!</div>
            <span class="text-xs">From&nbsp;{this.dealerName}</span>
          </div>

          <div class="flex py-2">
            <span class=" font-bold">Kelley Blue Book &#174;Instant Cash Offer&sup1;</span>
            <div class="border-dotted border-b-2 border-gray-600 border-t-0 border-l-0 border-r-0 mx-2 flex-grow"></div>
            <span class=" font-bold"> {formatCurrency(this.initialOfferAmount)}</span>
          </div>
          <div class="flex pb-2">
            <span class="text-clrs-dark-green">Dealer Boost&sup2;</span>
            <div class="border-dotted border-b-2 border-gray-600 border-t-0 border-l-0 border-r-0 mx-2 flex-grow"></div>
            <span class="text-clrs-dark-green"> +{formatCurrency(this.boost)}</span>
          </div>
        </div>

        <div class="text-clrs-grey flex lg:flex-row flex-col mt-2 pb-5 text-xs lg:justify-end">
          Dealer Boost amounts are determined and provided solely by, and can only be redeemed through, that Participating Dealer. Kelley Blue Book and its affiliates are not
          responsible for Offer adjustments, including Dealer Boosts
        </div>
      </div>
    );
  }
}
